export default "__VITE_ASSET__CzwcWJdO__";